// src/redux/actions/serviceTypeActions.js
export const setServiceType = (serviceType) => {
    return {
      type: 'SET_SERVICE_TYPE',
      payload: serviceType
    };
  };
  